import { IS_STAGING } from '../env.js';

export default function StagingBanner() {
  if (!IS_STAGING) return null;
  return (
    <div className="bg-amber-700 text-white text-sm text-center py-1.5 px-4 font-medium">
      STAGING — sends to real customers are blocked.
    </div>
  );
}
